export default function Philosophy() {
  return (
    <section id="philosophy" className="px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">企業理念・代表挨拶</h2>
        <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
          <div className="text-center mb-6">
            <div className="w-32 h-32 mx-auto mb-4 overflow-hidden rounded-full">
              <img 
                src="https://static.readdy.ai/image/54a81377d2a88f03463864bd512c4100/ab874f1d34272503209a88b2a3f02fc9.jpeg"
                alt="代表取締役 小島潤三郎"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-lg font-bold text-green-900 mb-1">代表取締役 小島潤三郎</h3>
            <p className="text-sm text-green-600">株式会社 SunAce</p>
          </div>
          <div className="space-y-4 text-sm text-green-700 leading-relaxed">
            <p>この度は、株式会社 SunAce のホームページをご覧いただき、誠にありがとうございます。</p>
            <p>当社は令和元年の設立以来、「確かな技術で安心をつくる」を理念のもと、電気工事のプロフェッショナルとして、住宅から大型施設・工場などの工事に携わってまいりました。</p>
            <p>電気は現代社会において重要なインフラです。</p>
            <p>技術の向上と安全の確保を第一に、お客様のご要望にお応えできるよう、スタッフ一同精進してまいります。</p>
          </div>
        </div>
        <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
          <h3 className="font-bold text-lg mb-4 text-center text-green-100">企業理念</h3>
          <div className="text-center mb-4">
            <p className="text-xl font-bold mb-2 text-green-100">確かな技術で安心をつくる</p>
          </div>
          <div className="space-y-3 text-sm">
            <div className="flex items-start">
              <div className="w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 rounded-full mr-3 mt-0.5">
                <i className="ri-shield-check-line text-sm text-green-100"></i>
              </div>
              <div>
                <h4 className="font-medium mb-1 text-green-100">安全第一の徹底</h4>
                <p className="text-xs opacity-90 text-green-100">全ての工事において安全を最優先とし、事故ゼロを継続します</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 rounded-full mr-3 mt-0.5">
                <i className="ri-tools-line text-sm text-green-100"></i>
              </div>
              <div>
                <h4 className="font-medium mb-1 text-green-100">技術力の向上</h4>
                <p className="text-xs opacity-90 text-green-100">常に最新の技術と知識を習得し、品質の高い工事を提供します</p>
              </div>
            </div>
            <div className="flex items-start">
              <div className="w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 rounded-full mr-3 mt-0.5">
                <i className="ri-handshake-line text-sm text-green-100"></i>
              </div>
              <div>
                <h4 className="font-medium mb-1 text-green-100">信頼関係の構築</h4>
                <p className="text-xs opacity-90 text-green-100">お客様との信頼関係を大切にし、長期的なパートナーシップを築きます</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
